module.exports = __webpack_public_path__ + "static/alan-eae7d75fa6b9450cc872ec3cfd27015b.jpg";